





























































































































import { Component, PropSync, Vue, Watch } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { Country } from "@/shared/models/country";
import { FinDocClientInfoViewModel, FinDocViewModel } from "./models";
import {
  FinancialDocumentStatusEnum,
  FinancialDocumentTypesEnum,
} from "@/shared/models/enums.type";
import VCustomer, { CustomerModel } from "@/shared/models/vCustomer";
import CustomerLookup from "@/components/misc/CustomerLookup.vue";
import CustomerForm from "@/components/CustomerForm.vue";
import LoadingOverlay from "@/components/misc/LoadingOverlay.vue";
import * as _ from "lodash";

@Component({
  components: {
    CustomerLookup,
    CustomerForm,
    LoadingOverlay,
  },
})
export default class ClientInfo extends Vue {
  @PropSync("finDocModel") finDocModelInternal!: FinDocViewModel;

  loading = false;
  customerLookupOpen = false;
  customerFormOpen = false;

  get clientInfo() {
    return this.finDocModelInternal.clientInfo;
  }

  get isLocked() {
    return (
      this.finDocModelInternal.documentStatusId !==
      FinancialDocumentStatusEnum.UIzradi
    );
  }

  get isCancellation() {
    return (
      this.finDocModelInternal.documentTypeId ===
      FinancialDocumentTypesEnum.Storno
    );
  }

  get city() {
    return [this.clientInfo?.postalCode, this.clientInfo?.city]
      .filter((x) => x)
      .join(" ");
  }

  get sortedCountries() {
    return this.countries
      ?.map((x) => ({
        id: x.id,
        text: this.$t(`Country.Official.${x.isoThreeLetterCode}`).toString(),
      }))
      .sort((a, b) => a.text.localeCompare(b.text));
  }

  get oib() {
    if (this.clientInfo?.isLegalEntity)
      return this.clientInfo?.businessId ?? "";
    return this.clientInfo?.identificationDocumentNumber ?? "";
  }
  set oib(value: string) {
    if (this.clientInfo.isLegalEntity) {
      this.clientInfo.businessId = value;
    } else {
      this.clientInfo.identificationDocumentNumber = value;
    }
  }

  get customerSearchHeaders() {
    const headers = [
      {
        text: "VCustomer.name",
        value: "name",
      },
      {
        text: "VFinancialDocument.Customer.oib",
        value: "identificationNumber",
      },
      {
        text: "VCustomer.countryOfResidenceName",
        value: "countryOfResidenceName",
      },
      {
        text: "VCustomer.eMail",
        value: "eMail",
      },
    ];

    return headers;
  }

  get filterPrefil() {
    return {
      name: this.clientInfo.name ?? "",
      identificationNumber: this.oib,
    };
  }

  openCustomerLookup() {
    if (!this.isLocked) {
      this.customerLookupOpen = true;
    }
  }

  selectedCopy?: FinDocClientInfoViewModel;
  unselect() {
    if (!_.isEqual(this.clientInfo, this.selectedCopy) && this.clientInfo.id) {
      this.clientInfo.id = 0;
      this.clientInfo.name = "";
      this.clientInfo.isLegalEntity = false;
      this.clientInfo.address = "";
      this.clientInfo.city = "";
      this.oib = "";
      this.clientInfo.postalCode = "";
      this.clientInfo.countryId = null;
      this.clientInfo.email = "";
      this.clientInfo.phone = "";
    }
  }

  selected(customer: VCustomer | CustomerModel) {
    if (this.clientInfo.id === customer.id) {
      this.loadCustomer(customer.id, 0);
    } else {
      this.clientInfo.id = customer.id;
    }
  }

  // refresh client data any time the client's ID is changed, as long as the document status is "U Izradi"
  @Watch("clientInfo.id")
  loadCustomer(fresh: number, old: number) {
    if (
      fresh &&
      fresh !== old &&
      this.finDocModelInternal.documentStatusId ===
        FinancialDocumentStatusEnum.UIzradi
    ) {
      this.loading = true;
      Vue.axios
        .get<CustomerModel>("/customers/" + fresh)
        .then((x) => {
          const result = x.data;

          this.clientInfo.id = result.id;

          this.clientInfo.isLegalEntity = result.isLegalEntity;
          this.clientInfo.name = result.isLegalEntity
            ? result.legalEntityName ?? ""
            : [result.firstName, result.lastName]
                .filter((e) => !!e && e.length > 0)
                .join(" ");

          this.clientInfo.countryId = result.countryOfResidenceId ?? null;
          this.oib = result.isLegalEntity
            ? result.businessId ?? ""
            : result.identificationDocumentNumber ?? "";
          this.clientInfo.email = result.eMail ?? "";
          this.clientInfo.phone = result.telephoneNumber ?? "";

          this.clientInfo.address = [result.streetName, result.houseNumber]
            .filter((x) => !!x && x.length > 0)
            .join(" ");
          this.clientInfo.postalCode = result.postalCode ?? "";
          this.clientInfo.city = result.city ?? "";

          this.selectedCopy = _.cloneDeep(this.clientInfo);
        })
        .finally(() => (this.loading = false));
    }
  }

  // validation
  get rules() {
    const required = (value: any) => !!value || this.$t("Validation.Required");

    return {
      required,
      requiredForLegalEntity: (value: any) =>
        !this.clientInfo.isLegalEntity || required(value),
      customerMustBeSelected: () =>
        !!this.clientInfo.id || this.$t("Customer must be selected"),
    };
  }

  // getters and setup
  @Action("codebooks/refreshCountries") refreshCountries?: () => Promise<void>;
  @Getter("codebooks/countries") countries?: Country[];

  async created() {
    const promises = [];

    if ((this.countries?.length ?? 0) === 0 && this.refreshCountries) {
      promises.push(this.refreshCountries());
    }

    await Promise.all(promises);
  }
}
